import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { fromPairs as _fromPairs , startCase} from 'lodash';

const namespacers = {
    myProfile: createNamespacer("MY_PROFILE"),
}

const initialstate = {
    firstname: {
        value: "",
        error: "",
        showError: "",
    },
    lastname: {
        value: "",
        error: "",
        showError: "",
    },
    email: {
        value: "",
        error: "",
        showError: "",
    },
    welderId: {
        value: "",
        error: "",
        showError: "",
    },
    contactNumber: {
        value: "",
        error: "",
        showError: "",
    },
    userTypes: {
        value: "",
        error: "",
        showError: "",
    },
    username: {
        value: "",
        error: "",
        showError: "",
    },
    profilePicture: {
        value: "",
        error: "",
        showError: "",
    },
    receiveNotificationId:'',
    roles: [],
    error: '',
    userTypeIds: [],
    showUserChangePassword: false,
    profilePictureSelected: false,
    notification: false,
    topManager: false,
    isTopManager: false,
    isWelder: false,
    scheduler: false,
}

const myProfileReducer = createReducer(initialstate, {
    SET_SHOW_USER_CHANGE_PASSWORD: (state, action) => {
        return {
            ...state,
            showUserChangePassword: action.payload.value,
        }
    },
    [namespacers.myProfile("SET_FIRSTNAME")]: (state, action) => {
        return {
            ...state,
            firstname: {
                ...state.firstname,
                value: action.payload.value,
            },
        }
    },
    [namespacers.myProfile("SET_LASTNAME")]: (state, action) => {
        return {
            ...state,
            lastname: {
                ...state.lastname,
                value: action.payload.value,
            },
        }
    },
    [namespacers.myProfile("SET_EMAIL")]: (state, action) => {
        return {
            ...state,
            email: {
                ...state.email,
                value: action.payload.value
            },
        }
    },
    [namespacers.myProfile("SET_WELDER_ID")]: (state, action) => {
        return {
            ...state,
            welderId: {
                ...state.welderId,
                value: action.payload.value
            },
        }
    },
    [namespacers.myProfile("SET_CONTACT_NUMBER")]: (state, action) => {
        return {
            ...state,
            contactNumber: {
                ...state.contactNumber,
                value: action.payload.value
            },
        }
    },
    [namespacers.myProfile("SET_USERNAME")]: (state, action) => {
        return {
            ...state,
            username: {
                ...state.username,
                value: action.payload.value
            },
        }
    },
    [namespacers.myProfile("TOGGLE_NOTIFICATION")]: (state,action) => {
        return {
            ...state,
            notification: action.payload.value,
        }
    },
    [namespacers.myProfile("SET_TOP_MANAGER")]: (state,action) => {
        return {
            ...state,
            topManager: action.payload.value,
        }
    },
    [namespacers.myProfile("SET_IS_WELDER")]: (state,action) => {
        return {
            ...state,
            isWelder: action.payload.value,
        }
    },
    SET_IS_TOP_MANAGER: (state,action) => {
        return {
            ...state,
            isTopManager: action.payload.value,
        }
    },
    [namespacers.myProfile("SET_PROFILE_PICTURE")]: (state, action) => {
        return {
            ...state,
            profilePicture: {
                ...state.profilePicture,
                value: action.payload.value,
            },
            profilePictureSelected: true,
        }
    },
    [namespacers.myProfile("LOAD_DATA")]: (state, action) => {
        const responseMapping = {
            firstname: 'first_name',
            lastname: 'last_name',
            email: 'email',
            welderId:'welder_id',
            contactNumber: 'mobile',
            username: 'user_name',
        }

        // TODO: Add user type from roles api

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                return [key, {
                    ...state[key],
                    value: action.payload.value[responseKey] || ''
                }]
            })
        )
        
        loadedFields.userTypes = {
            ...state.userTypes,
            value: action.payload.value.roles.map((userRole) => {
                return { id: userRole.id, value: userRole.role_id, label: userRole.role_name == "Qa" ? 'QA/QC' : userRole.role_name}
            })
        }
        loadedFields.userTypeIds = action.payload.value.roles.map(userRole => userRole.role_id)

        let profilePicture = action.payload.value.thumb_url || "";

        return {
            ...state,
            ...loadedFields,
            profilePicture: {
                ...state.profilePicture,
                value: profilePicture,
            },
            notification: action.payload.value.receive_notification,
            topManager: action.payload.value.top_manager,
            isWelder: action.payload.value.is_welder ? action.payload.value.is_welder : (action.payload.value.welder_id ? true : false),
            receiveNotificationId: action.payload.value.receive_notification_id
        }
    },
    [namespacers.myProfile("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.myProfile("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialstate,
        }
    },
    [namespacers.myProfile("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
    [namespacers.myProfile("SET_SCHEDULER")]: (state, action) => {
        return {
            ...state,
            scheduler: action.payload.value,
        }
    },
})

export default myProfileReducer;
